import { gql } from '@apollo/client';

export * from './invoices.query.generated';

export const INVOICES = gql`
  query invoices($offset: String, $unpaid: Boolean) {
    invoices(offset: $offset, unpaid: $unpaid) {
      nodes {
        id
        date
        total
        currencyCode
        status
      }
      nextOffset
    }
  }
`;
